import { usePermissionStore } from '@manager/store/permission-store';
import type { IPermission } from '@manager/types/permission-types';
import { isArray } from 'lodash-es';

function getPermissionArray(
  permission?: IPermission | IPermission[]
): IPermission[] {
  if (!permission) {
    return [];
  }
  return !isArray(permission) ? [permission] : permission;
}

export function useCan() {
  const permissionStore = usePermissionStore();

  function can(permission: IPermission): boolean {
    if (!permission) {
      return true;
    }
    const permissions: IPermission[] = permissionStore.permissions || [];
    return permissions.includes(permission as IPermission);
  }

  function canSome(permissions?: IPermission | IPermission[]): boolean {
    if (!permissions) {
      return true;
    }
    const allPermissions: IPermission[] = permissionStore.permissions || [];
    return getPermissionArray(permissions).some((perm) =>
      allPermissions.includes(perm)
    );
  }

  return { can, canSome };
}
